import { render, staticRenderFns } from "./Brandassets.vue?vue&type=template&id=592f425e&scoped=true&"
import script from "./Brandassets.vue?vue&type=script&lang=js&"
export * from "./Brandassets.vue?vue&type=script&lang=js&"
import style0 from "./Brandassets.vue?vue&type=style&index=0&id=592f425e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f425e",
  null
  
)

export default component.exports